import React, { Component } from 'react';
import {Col,Row,Container, Card,CardDeck,Button} from 'reactstrap';
import SubModule from './SubModule';

class LandingItem extends Component {
  constructor(props){
    super(props);
    this.handleButtonClick= this.handleButtonClick.bind(this)
  }
         
  handleButtonClick(event) {     
    this.refs.child.updateState(event.target.value);
  }
      
  render(){

    return(      
       <Container>
         <Row>
           <Col md="7">
            <SubModule ref="child"/>
           </Col>
         </Row>
         <Row>
           <Col md="7">
              <CardDeck>
                 <Card>
                     <Button outline color="dark" className="cui-briefcase icons landingBtn " size="lg" onClick={this.handleButtonClick} value={"BCM"} > </Button>                 
                </Card>
                <Card>              
                     <Button outline color="dark" className="fa fa-building-o landingBtn" size="lg" onClick={this.handleButtonClick} value={"ERM"}  ></Button>                
                </Card>
                <Card>          
                   <Button outline color="dark" className="cui-task icons landingBtn" size="lg" onClick={this.handleButtonClick} value={"CM"} ></Button>           
                </Card>                   
             </CardDeck>   
            </Col>
           </Row>    
       </Container>
  );   
  }
}
export default LandingItem;
